/**
 * Marketing attribution capture.
 * Captures Google Ads gclid + UTM params on first landing and persists them so
 * they survive navigation to a lead-capture form. Submit getAttribution() with
 * any lead so ad traffic is tied to the CRM enquiry.
 */
const KEY = 'corvana_attribution';

export function captureAttribution() {
  if (typeof window === 'undefined') return {};
  const p = new URLSearchParams(window.location.search);
  let stored = {};
  try { stored = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { stored = {}; }
  const next = { ...stored };
  for (const k of ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']) {
    const v = p.get(k);
    if (v) next[k] = v;
  }
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* ignore */ }
  return next;
}

export function getAttribution() {
  if (typeof window === 'undefined') return {};
  try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; }
}
